const QRCode = require('qrcode');
const qrCodeHandlers = require('@/libraries/DigiTickets/QrCodeHandlers/qrCodeHandlers');

const qrCodeDirective = function () {
    return {
        link: function link(scope, element, attrs) {
            const options = {
                errorCorrectionLevel: 'M', // Default
                width: 150,
                height: 150,
                color: {
                    dark: '#000000',
                    light: '#FFFFFF',
                },
            };

            if (qrCodeHandlers[attrs.handler] !== undefined) {
                const qrObj = attrs.data !== undefined
                    ? qrCodeHandlers[attrs.handler](attrs.data)
                    : qrCodeHandlers[attrs.handler]();

                if (qrObj.content) {
                    QRCode.toDataURL(qrObj.content, options)
                        .then((url) => {
                            element.html(`<div id="qrDiv"><img src="${url}" width="${options.width}" height="${options.height}" /></div>`);
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                } else {
                    console.debug('dt-qr-code directive was called with no content');
                }
            } else {
                console.debug('dt-qr-code directive attempted to call a missing handler');
            }
        },
    };
};

module.exports = qrCodeDirective;
